import { useQuery } from "@tanstack/react-query";
import {
  categorizeOrder,
  getOrder,
  listOrders,
  type ListOrdersParams,
} from "../services/orderService";
import type { Order } from "../../../entities/order";

export const ORDERS_LIST_QUERY_KEY   = ["orders", "list"]   as const;
export const ORDER_DETAIL_QUERY_KEY  = ["orders", "detail"] as const;

export type OrdersListFilter = "active" | "done" | "cancelled";

// Liste serveur paginée + filtrage côté client par catégorie.
// Le backend n'a pas d'endpoint "active/done/cancelled" — on tape /orders avec
// `per_page` élevé puis on découpe. Pour de la pagination réelle, utiliser
// directement `listOrders({ status, page, per_page })`.

export function useOrders(filter?: OrdersListFilter, params: ListOrdersParams = {}) {
  return useQuery({
    queryKey:  [...ORDERS_LIST_QUERY_KEY, filter ?? "all", params],
    queryFn:   () => listOrders({ per_page: 50, ...params }),
    staleTime: 15_000,
    select: (res): Order[] => {
      const all = res.data;
      if (!filter) return all;
      return all.filter((o) => categorizeOrder(o) === filter);
    },
  });
}

export function useOrderDetail(orderId: string | undefined) {
  return useQuery({
    queryKey:  [...ORDER_DETAIL_QUERY_KEY, orderId],
    queryFn:   () => getOrder(orderId!),
    enabled:   Boolean(orderId),
    staleTime: 30_000,
  });
}
